import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b7d5a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "streak-badge__icon" }
const _hoisted_2 = { class: "streak-badge__count" }
const _hoisted_3 = { class: "streak-badge__label" }




export default /*#__PURE__*/_defineComponent({
  __name: 'StreakOffensive',
  props: {
  offensive: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["streak-badge", { 'on-fire': __props.offensive.today_is_in_streak }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_icon, {
        name: "whatshot",
        size: "18px"
      })
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.offensive.days), 1),
    _createElementVNode("span", _hoisted_3, " day" + _toDisplayString(__props.offensive.days !== 1 ? 's' : ''), 1)
  ], 2))
}
}

})